import React from 'react';
import { Box } from '@chakra-ui/react';

const Badge = ({ text, ...props }) => {
  return (
    <Box
      fontSize={{ base: `xs`, md: `sm` }}
      display="inline-flex"
      py="2px"
      px="3"
      color="gray.600"
      bg="teal.50"
      borderRadius="50px"
      fontWeight="600"
      {...props}>
      {text}
    </Box>
  );
};
export default Badge;
